import React from 'react';
import TablzLogo from '../../images/poweredBy/tablz.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import Spinner from '../Spinner';
import { useTranslation } from 'react-i18next';

export const Loading = () => {
	const { t } = useTranslation();

	return (
		<ResultPageLayout>
			<img src={TablzLogo} />

			<ResultPageLayout.Title>{t('messages.confirming_booking')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<Spinner size='xs' />
			</ResultPageLayout.Body>
		</ResultPageLayout>
	);
};
